import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../../shared/tr-icons'
import Breakout from '../breakout/Breakout'
import {
  StyledTooltip,
  StyledTooltipTrigger,
  StyledTooltipPointer,
  StyledTooltipText,
  StyledTooltipTextInner
} from './Tooltip.styles'

export default class Tooltip extends Component {
  render() {
    const {
      text,
      icon,
      truncate,
      resized,
      visible,
      style,
      className,
      triggerStyle,
      textElementStyle,
      closeToTop,
      getRefTooltipText,
      getRefTooltipTextInner,
      getRefTooltipTrigger,
      mouseEnterHandler,
      mouseLeaveHandler,
      children,
      triggerElement
    } = this.props

    const iconType = icon || 'question'
    const isIcon = !children
    
    const content = <React.Fragment>
        <StyledTooltipPointer
          visible={visible}
          closeToTop={closeToTop}
          data-testid='tooltip-arrow'
        />
        <StyledTooltipText
          innerRef={getRefTooltipText}
          visible={visible}
          truncate={truncate}
          extraStyles={textElementStyle}
          closeToTop={closeToTop}
          data-testid={`tooltip-text-${visible ? 'visible' : 'hidden'}`}
        >
          <StyledTooltipTextInner innerRef={getRefTooltipTextInner} resized={resized}>
            {text}
          </StyledTooltipTextInner>
        </StyledTooltipText>
      </React.Fragment>

    const breakoutStyle = { pointerEvents: 'none', zIndex: 100 }
    const useBreakout = visible && Boolean(triggerElement)

    return (
      <StyledTooltip className={className} truncate={truncate} isIcon={isIcon} style={style}>
        <StyledTooltipTrigger
          innerRef={getRefTooltipTrigger}
          style={triggerStyle}
          truncate={truncate}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          data-testid='tooltip-trigger'
        >
          {isIcon && <Icon type={iconType} grey={true} data-testid='tooltip-icon' />}
          {!isIcon && children}
        </StyledTooltipTrigger>

      { 
        useBreakout 
        ? <Breakout trackElement={triggerElement} style={breakoutStyle}>{ content }</Breakout>
        : content
      }

      </StyledTooltip>
    )
  }
}

Tooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  truncate: PropTypes.bool,
  resized: PropTypes.bool,
  visible: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  closeToTop: PropTypes.bool,
  textElementStyle: PropTypes.object,
  triggerStyle: PropTypes.object,
  getRefTooltipText: PropTypes.func.isRequired,
  getRefTooltipTextInner: PropTypes.func.isRequired,
  mouseEnterHandler: PropTypes.func.isRequired,
  mouseLeaveHandler: PropTypes.func.isRequired
}
